

export const IsCorujaFlow = () => 
  localStorage.getItem("corujaFlow")?.toLowerCase() === 'true';

export const IsRdgoFlow = () => 
  localStorage.getItem("rdgoFlow")?.toLowerCase() === 'true';

export const IsRbmFlow = () => 
  localStorage.getItem("rbmFlow")?.toLowerCase() === 'true';
